import React from 'react';

import { Activity } from '../types';

interface Props {
  activities: Activity[];
}

export default (props: Props) => {
  const aiTutorActivities = () => {
    return props.activities.every((activity) => activity.type === 'ai_tutor');
  };

  const practiceActivities = () => {
    return props.activities.every((activity) => activity.type === 'practice');
  };

  if (practiceActivities()) {
    return (
      <h4 className="text-center u-margin-A-n"><strong>Check Your Understanding!</strong></h4>
    );
  } else if (aiTutorActivities()) {
    return (
      <div className="d-flex flex-column gap-s">
        <h3 className="hidden-xs u-margin-A-n"><strong>Still Need Help?</strong></h3>
        <div>Get more help with our AI Tutor.</div>
      </div>
    );
  } else {
    return null;
  }
};
